import { render, staticRenderFns } from "./ConfiguratorInfo.vue?vue&type=template&id=63c91260"
import script from "./ConfiguratorInfo.vue?vue&type=script&lang=ts"
export * from "./ConfiguratorInfo.vue?vue&type=script&lang=ts"
import style0 from "./ConfiguratorInfo.vue?vue&type=style&index=0&id=63c91260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports